<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34.867"
    height="24.697"
    viewBox="0 0 34.867 24.697"
  >
    <g id="cargo-truck" transform="translate(0 -4)">
      <path
        id="Path_1700"
        data-name="Path 1700"
        d="M22.518,25.792H9.443a.726.726,0,1,1,0-1.453H21.792V5.453H1.453V24.339H3.632a.726.726,0,0,1,0,1.453H.726A.727.727,0,0,1,0,25.065V4.726A.727.727,0,0,1,.726,4H22.518a.727.727,0,0,1,.726.726V25.065A.727.727,0,0,1,22.518,25.792Z"
        :fill="color"
      />
      <path
        id="Path_1701"
        data-name="Path 1701"
        d="M27.349,24.433H23.717a.726.726,0,0,1,0-1.453h2.906V13.538a5.09,5.09,0,0,0-5.085-5.085H16.453V22.981h1.453a.726.726,0,0,1,0,1.453H15.726A.727.727,0,0,1,15,23.707V7.726A.727.727,0,0,1,15.726,7h5.811a6.545,6.545,0,0,1,6.538,6.538V23.707A.727.727,0,0,1,27.349,24.433Z"
        transform="translate(6.792 1.358)"
        :fill="color"
      />
      <path
        id="Path_1702"
        data-name="Path 1702"
        d="M20.132,23.264a3.632,3.632,0,1,1,3.632-3.632A3.636,3.636,0,0,1,20.132,23.264Zm0-5.811a2.179,2.179,0,1,0,2.179,2.179A2.182,2.182,0,0,0,20.132,17.453Z"
        transform="translate(7.471 5.433)"
        :fill="color"
      />
      <path
        id="Path_1703"
        data-name="Path 1703"
        d="M5.632,23.264a3.632,3.632,0,1,1,3.632-3.632A3.636,3.636,0,0,1,5.632,23.264Zm0-5.811a2.179,2.179,0,1,0,2.179,2.179A2.182,2.182,0,0,0,5.632,17.453Z"
        transform="translate(0.906 5.433)"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "Shipment_Send_Icon",
  props: {
    color: {
      default: "#1C274C",
    },
  },
};
</script>
